import { render, staticRenderFns } from "./createGradeModal.vue?vue&type=template&id=56594431&"
import script from "./createGradeModal.vue?vue&type=script&lang=js&"
export * from "./createGradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports